import { createSolarApi } from './core/api/solarApi.js';
import { createAshpApi } from './core/api/ashpApi.js';
import { createFinanceApi } from './core/api/financeApi.js';
import { formatCurrencyGBP, formatNumber, formatPercent } from './core/utils/format.js';
import { debounce } from './core/utils/debounce.js';
import { getQueryParam, getQueryParams } from './core/utils/params.js';
import { getStoredItem, setStoredItem, removeStoredItem } from './core/utils/storage.js';
import { bindGrowthCtas, trackGrowthCta } from './core/growth/cta.js';

const dwellow = typeof window !== 'undefined'
    ? (window.Dwellow = window.Dwellow || {})
    : {};

dwellow.core = {
    api: { createSolarApi, createAshpApi, createFinanceApi },
    utils: {
        formatCurrencyGBP,
        formatNumber,
        formatPercent,
        debounce,
        getQueryParam,
        getQueryParams,
        getStoredItem,
        setStoredItem,
        removeStoredItem
    }
};

bindGrowthCtas();
dwellow.growth = { bindCtas: bindGrowthCtas, trackCta: trackGrowthCta };

export {
    createSolarApi,
    createAshpApi,
    createFinanceApi,
    formatCurrencyGBP,
    formatNumber,
    formatPercent,
    debounce,
    getQueryParam,
    getQueryParams,
    getStoredItem,
    setStoredItem,
    removeStoredItem
};
